// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"185":"ee9a683ea301a336","534":"b97550c44d53bf53","931":"b161dcd74afc8b1a"}[chunkId] + ".css";
};